<script setup lang="ts">
import { RouterLink } from "vue-router";
import { useMyNotices } from "../api/use-platform";
import { usePlatformI18n } from "../i18n/use-platform-i18n";

/**
 * A FAIXA DE AVISO que o workspace vê — irmã da faixa de suporte, no mesmo
 * lugar e com o mesmo relógio: aparece e some sozinha quando o aviso vence ou
 * é revogado. A MENSAGEM sai exatamente como foi escrita, nunca traduzida —
 * é a frase que alguém assinou na plataforma.
 *
 * O tom vem do desenho (info/success/warning/danger), nunca um hex solto: a
 * faixa fala a paleta do painel em qualquer tema.
 */
const props = defineProps<{ enabled: boolean }>();

const { data: notices } = useMyNotices(() => props.enabled);
const { t } = usePlatformI18n();

const TONES: Record<string, string> = {
	info: "border-accent-border/40 bg-accent-subtle text-accent",
	success: "border-success/30 bg-success-subtle text-success",
	warning: "border-warning/30 bg-warning-subtle text-warning",
	danger: "border-danger/30 bg-danger-subtle text-danger",
};
</script>

<template>
	<div
		v-for="notice in notices ?? []"
		:key="notice.id"
		class="flex flex-wrap items-center gap-x-2 gap-y-1 border-b px-3 py-1.5 text-xs sm:px-5"
		:class="TONES[notice.tone] ?? TONES.info"
		role="status"
	>
		<!-- Só a mensagem: o prazo é assunto interno da plataforma (o dono, 22/08) —
		     quem lê o recado não precisa saber quando ele se desliga. -->
		<span class="font-medium">{{ notice.message }}</span>
		<!-- A porta do recado: caminho do painel navega aqui; URL abre fora. -->
		<RouterLink
			v-if="notice.link?.startsWith('/')"
			:to="notice.link"
			class="font-medium underline underline-offset-2"
		>
			{{ t("notice.open") }}
		</RouterLink>
		<a
			v-else-if="notice.link"
			:href="notice.link"
			target="_blank"
			rel="noopener"
			class="font-medium underline underline-offset-2"
		>
			{{ t("notice.open") }}
		</a>
	</div>
</template>
